"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestAbortedError = exports.RequestError = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("../enums/errors");
/**
 * An error that was thrown during the process of making a request.
 */
var RequestError = /** @class */ (function (_super) {
    tslib_1.__extends(RequestError, _super);
    function RequestError(message, code, status, url) {
        var _this = _super.call(this, message) || this;
        _this.name = 'RequestError';
        _this.message = message;
        _this.code = code;
        _this.status = status || 0;
        _this.url = url;
        return _this;
    }
    return RequestError;
}(Error));
exports.RequestError = RequestError;
var RequestAbortedError = /** @class */ (function (_super) {
    tslib_1.__extends(RequestAbortedError, _super);
    function RequestAbortedError(url) {
        var _this = _super.call(this, 'Request aborted by signal.', errors_1.TransportErrors.HTTP_REQUEST_ABORTED, 0, url) || this;
        _this.name = 'RequestAbortedError';
        _this.message = 'Request aborted by signal.';
        return _this;
    }
    return RequestAbortedError;
}(RequestError));
exports.RequestAbortedError = RequestAbortedError;
//# sourceMappingURL=request.js.map